<template>
  	<ResellerList />
</template>

<script>

// @ is an alias to /src
import ResellerList from "@/components/Client/Resellers/ResellerList.vue";

export default {
  name: "ResellerLists",
  components: {
    ResellerList,
  },
};
</script>
